import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { useCurrentOrganizationPreviewSharedQuery } from '@entities/organization/libs/hooks/use-current-organization-preview-shared-query/use-current-organization-preview-shared-query';
import { useEffect } from 'react';

export const useCurrentOrganizationPreview = () => {
    const user = useCurrentUserSelector();
    const companyId = user?.company?.id;
    const [getCurrentOrganizationPreview] = useCurrentOrganizationPreviewSharedQuery(user?.company?.id || 0);

    useEffect(() => {
        if (companyId) {
            getCurrentOrganizationPreview(companyId);
        }
    }, [companyId]);
};
